import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../../../navigators';
import {SuccessTemplate} from '../../../../components/templates/success';
import {PrimaryButton} from '../../../../components/buttons';
import {Box} from 'native-base';
import {message as t} from '../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'SalesmanNewClientRequestSuccess'
>;

const popBackCount = 4; // to dashboard

export const SalesmanNewClientRequestSuccess = ({navigation}: ScreenProps) => {
  const handlePrimaryPress = async () => {
    navigation.pop(popBackCount);
  };

  return (
    <SuccessTemplate
      title={t('salesman-new-client-success-title')}
      summary={t('salesman-new-client-success-summary')}>
      <PrimaryButton
        label={t('salesman-new-client-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <Box height={60} width={'100%'} />
    </SuccessTemplate>
  );
};
